<template>
    <section class="section">
        <h1 class="title is-4">Log ind</h1>

        <div v-if="error" class="notification is-danger">
            E-mail/adgangskode og/eller token er forkert.
        </div>
        <div v-if="errorTwoFactor" class="notification is-danger">
            Kunne ikke sende two-factor token
        </div>

        <form v-if="!showTwoFactorForm" @submit.prevent="enterTwoFactorToken">
            <div class="field">
                <div class="control">
                    <input
                        class="input"
                        type="email"
                        placeholder="E-mail"
                        v-model="email"
                    />
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <input
                        class="input"
                        type="password"
                        placeholder="Adgangskode"
                        v-model="password"
                    />
                </div>
            </div>

            <button
                class="button is-link"
                :class="{ 'is-loading': loading }"
                :disabled="loading"
            >
                Log ind
            </button>
            <router-link
                :to="{ name: 'forgot-password' }"
                class="button is-text is-pulled-right"
            >
                Nulstil password
            </router-link>
        </form>
        <form v-else @submit.prevent="login">
            <div class="field">
                <div class="control">
                    Indtast token:
                    <input
                        class="input"
                        type="text"
                        placeholder="Token"
                        v-model="twofactor_token"
                    />
                </div>
            </div>
            <button
                class="button is-link"
                :class="{ 'is-loading': loading }"
                :disabled="loading"
            >
                Log ind
            </button>
        </form>
    </section>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            showPasswordFields: false,
            email: "",
            password: "",
            twofactor_token: "",
            error: false,
            errorTwoFactor: false,
            showTwoFactorForm: false,
            twoFactorSecret: null,
        };
    },
    methods: {
        submit() {
            this.showPasswordFields ? this.login() : this.getTwoFactorCode();
        },
        enterTwoFactorToken() {
            this.showPasswordFields = false;
            this.errorTwoFactor = false;
            this.showTwoFactorForm = false;
            this.loading = true;

            window.axios
                .post("/api/twofactor", {
                    email: this.email,
                    password: this.password,
                })
                .then((response) => {
                    this.twoFactorSecret = response.data.secret;
                    this.showPasswordFields = true;
                    this.showTwoFactorForm = true;
                    this.loading = false;
                })
                .catch((error) => {
                    this.showPasswordFields = false;
                    this.errorTwoFactor = true;
                    this.loading = false;
                });
        },
        login() {
            this.loading = true;
            this.error = false;
            window.axios
                .post("/api/login", {
                    twofactor_token_hash: this.twoFactorSecret,
                    twofactor: this.twofactor_token,
                })
                .then((response) => {
                    this.loading = false;
                    this.$store.dispatch("setUser", response.data);
                    this.$router.push({ name: "home" });
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = true;
                    this.$store.dispatch("setUser", null);
                });
        },
    },
};
</script>
